export const blogAuthorIds = [
  'zane-cole',
  'arlo-vance',
  'kiran-patel',
  'devon-reed',
] as const

export type BlogAuthorId = (typeof blogAuthorIds)[number]

export type BlogAuthor = Readonly<{
  id: BlogAuthorId
  name: string
}>

/**
 * The public author registry intentionally contains verified names only.
 * Add biography, role, profile image, or credentials only after the author has
 * reviewed and approved that information.
 */
export const blogAuthors = {
  'zane-cole': { id: 'zane-cole', name: 'Zane Cole' },
  'arlo-vance': { id: 'arlo-vance', name: 'Arlo Vance' },
  'kiran-patel': { id: 'kiran-patel', name: 'Kiran Patel' },
  'devon-reed': { id: 'devon-reed', name: 'Devon Reed' },
} as const satisfies Record<BlogAuthorId, BlogAuthor>

export const blogAuthorList = blogAuthorIds.map((authorId) => blogAuthors[authorId])

const topicClusterAuthorIds = {
  'agency-donation-toolkit': 'devon-reed',
  'ai-website-donations': 'devon-reed',
  'campaign-planning': 'zane-cole',
  'donation-conversion': 'arlo-vance',
  'donation-growth': 'arlo-vance',
  'donor-retention': 'arlo-vance',
  'fundraising-basics': 'zane-cole',
  'fundraising-software-comparisons': 'kiran-patel',
  'payment-processor-choices': 'kiran-patel',
  'recurring-giving': 'arlo-vance',
  'small-nonprofit-growth': 'zane-cole',
  'state-guides': 'zane-cole',
  'stripe-donation-forms': 'kiran-patel',
  'website-builder-donations': 'devon-reed',
  'website-donation-experience': 'devon-reed',
  'wordpress-donation-software': 'devon-reed',
  'year-end-fundraising': 'zane-cole',
} as const satisfies Record<string, BlogAuthorId>

export function getBlogAuthor(authorId: BlogAuthorId): BlogAuthor {
  return blogAuthors[authorId]
}

export function getBlogAuthorForTopicCluster(
  topicCluster: string,
  explicitAuthorId?: BlogAuthorId,
): BlogAuthor {
  if (explicitAuthorId) {
    return getBlogAuthor(explicitAuthorId)
  }

  const authorId = topicClusterAuthorIds[topicCluster as keyof typeof topicClusterAuthorIds]

  if (!authorId) {
    throw new Error(
      `No blog author is assigned to topic cluster "${topicCluster}". Add the cluster to blog-authors.ts or set an explicit authorId.`,
    )
  }

  return getBlogAuthor(authorId)
}
